// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

import { IS_SENTRY_ENABLED } from "@/lib/env";

if (IS_SENTRY_ENABLED) {
  Sentry.init({
    dsn: "https://d8e2a29acb245093170aa85cb4c93eaa@o4510479787360256.ingest.us.sentry.io/4510479789719552",

    // Add optional integrations for additional features
    integrations: [Sentry.replayIntegration()],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,
    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Enable sending user PII (Personally Identifiable Information)
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    ignoreErrors: [
      /Failed to connect to MetaMask/,
      /window\.webkit\.messageHandlers/,
      // Instagram/Facebook Android in-app browser native bridge (NOMBOX-Q)
      /Java object is gone/,
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      // Scripts injected by in-app browsers (Instagram/Facebook)
      /navigation_performance_logger/i,
      // Third-party Umami script; throws when storage is blocked (NOMBOX-R)
      /\/api\/analytics\/script\.js/i,
    ],
    beforeSend(event) {
      const frames = event.exception?.values?.[0]?.stacktrace?.frames;
      if (frames?.some((f) => f.function?.includes("addEL_hook"))) return null;
      return event;
    },
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
